const PagePathConstants = {
  ROOT_PAGE                     : "/",
  TESLA                         : "/tesla",
  TESLA_ORDER                   : "/tesla_order",
  VEHICLE_MODEL                 : "/vehicle_model",
  CUSTOM_INFO                   : "/custom_info",
  DOCUMENT_INFO                 : "/document_info",
  PROOF_OF_ADDRESS              : "/proof_of_address",
  PROOF_OF_W2                   : "/proof_of_w2",
  PROOF_OF_1040			            : "/proof_of_1040",
  IRS_PIN_PROOF			            : "/irs_pin_proof",
  SELFIE_INFO                   : "/selfie_info",
  ORDER_CONFIRM                 : "/order_confirm",
  SUCCESS_CALLBACK              : "/success_callback",
  SUBMISSION_CALLBACK           : "/submission_callback",
  PAYMENT_INFO                  : "/payment_info",
  SEND_CODE                     : "/send_code",
}

export default PagePathConstants;
